import React from 'react'
import { Eye, EyeClosed, LockKey } from '@phosphor-icons/react'
import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'
import { LOGIN_FIELD_SX } from './loginConstants'

export default function LoginPasswordField({
  id,
  label,
  name,
  value,
  onChange,
  showPassword,
  onTogglePassword,
  autoComplete = 'new-password',
  autoFocus = false,
  minLength = 8,
  error = '',
  helperText,
  fieldSx = LOGIN_FIELD_SX
}) {
  return (
    <TextField
      id={id}
      label={label}
      variant="outlined"
      fullWidth
      type={showPassword ? 'text' : 'password'}
      name={name}
      value={value}
      onChange={onChange}
      autoComplete={autoComplete}
      autoFocus={autoFocus}
      required
      error={Boolean(error)}
      helperText={error || helperText}
      sx={fieldSx}
      slotProps={{
        htmlInput: { minLength },
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <LockKey className="login-field-icon" size={18} />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                edge="end"
                onClick={onTogglePassword}
              >
                {showPassword ? (
                  <Eye className="login-field-icon" size={18} />
                ) : (
                  <EyeClosed className="login-field-icon" size={18} />
                )}
              </IconButton>
            </InputAdornment>
          )
        }
      }}
    />
  )
}
